// Static content data for the portfolio
export const OWNER = {
  name: "Sunil KP",
  firstName: "Sunil",
  title: "Website Designer & Frontend Developer",
  tagline: "I craft modern, responsive, and high-converting websites that help businesses grow online.",
  email: "databasesmartmarketing2021@gmail.com",
  phone: "+919449653940",
  phoneDisplay: "+91 94496 53940",
  whatsapp: "919449653940",
  location: "Muguthihalli, Chikmagalur, Karnataka — 577133",
  linkedin: "https://www.linkedin.com/in/sunisunil165",
  github: "https://github.com/sunisunil165-web",
};

export const PORTRAIT_URL = "https://customer-assets.emergentagent.com/job_7896010f-7906-4b51-b567-bf108a4b0e6f/artifacts/ct6yo2g9_image%20my.jfif";

export const VOICE_GREETING = "Hi, welcome to my portfolio! I'm Sunil, a Website Designer and Frontend Developer. Explore my work and let's build something amazing together.";

export const SERVICES = [
  { key: "web-design", title: "Website Design", desc: "Pixel-perfect, brand-aligned designs that convert visitors into customers.", icon: "PenTool" },
  { key: "landing", title: "Landing Pages", desc: "High-converting landing pages built for campaigns, launches, and ad funnels.", icon: "Rocket" },
  { key: "business", title: "Business Websites", desc: "Professional multi-page websites that establish authority and trust.", icon: "Briefcase" },
  { key: "ecommerce", title: "E-commerce Websites", desc: "Fast, mobile-first online stores with clean checkout and product flows.", icon: "ShoppingCart" },
  { key: "redesign", title: "Website Redesign", desc: "Give your outdated site a modern, faster, SEO-friendly makeover.", icon: "Sparkles" },
  { key: "uiux", title: "UI/UX Design", desc: "Figma-first user experiences designed for clarity, speed, and delight.", icon: "Layers" },
  { key: "maintenance", title: "Website Maintenance", desc: "Ongoing updates, backups, performance and security monitoring.", icon: "ShieldCheck" },
];

export const SKILLS = [
  { name: "HTML5", level: 98 },
  { name: "CSS3", level: 96 },
  { name: "JavaScript", level: 90 },
  { name: "React", level: 88 },
  { name: "Tailwind CSS", level: 95 },
  { name: "Bootstrap", level: 92 },
  { name: "Figma", level: 88 },
  { name: "WordPress", level: 90 },
  { name: "Git", level: 85 },
  { name: "GitHub", level: 85 },
];

export const CATEGORIES = [
  { key: "all", label: "All Work" },
  { key: "homestay", label: "Homestays" },
  { key: "hotel", label: "Hotels" },
  { key: "coffee", label: "Coffee Shops" },
  { key: "school", label: "Schools & Colleges" },
  { key: "ecommerce", label: "E-commerce" },
  { key: "business", label: "Business" },
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Malnad Retreat Homestay",
    category: "homestay",
    image: "https://images.unsplash.com/photo-1771749607057-17163af1f0f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjb3p5JTIwaG9tZXN0YXklMjBuYXR1cmV8ZW58MHx8fHwxNzgzMTQ4ODExfDA&ixlib=rb-4.1.0&q=85",
    desc: "Cozy homestay booking site with rooms, tariffs, and enquiry forms nestled in Chikmagalur hills.",
    tech: ["React", "Tailwind", "Framer Motion"],
    live: "#",
    github: "#",
  },
  {
    id: "p2",
    title: "Coorg Coffee Estate Stay",
    category: "homestay",
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&q=80",
    desc: "Immersive plantation stay booking experience with photo galleries and seasonal offers.",
    tech: ["WordPress", "Elementor", "SEO"],
    live: "#",
    github: "#",
  },
  {
    id: "p3",
    title: "Grand Vista Hotel",
    category: "hotel",
    image: "https://images.pexels.com/photos/3011575/pexels-photo-3011575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Luxury 5-star hotel website with room booking, spa, dining, and event pages.",
    tech: ["React", "Node", "Stripe"],
    live: "#",
    github: "#",
  },
  {
    id: "p4",
    title: "Brew & Bloom Café",
    category: "coffee",
    image: "https://images.pexels.com/photos/34393282/pexels-photo-34393282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Warm, community-driven coffee shop site with menu, story, and online reservations.",
    tech: ["HTML5", "CSS3", "JavaScript"],
    live: "#",
    github: "#",
  },
  {
    id: "p5",
    title: "The Roastery",
    category: "coffee",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1200&q=80",
    desc: "Specialty coffee roasters website with online bean shop and subscription flow.",
    tech: ["React", "Shopify", "Tailwind"],
    live: "#",
    github: "#",
  },
  {
    id: "p6",
    title: "Vidyapeetha Public School",
    category: "school",
    image: "https://images.pexels.com/photos/31656148/pexels-photo-31656148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "K-12 school website with admissions, campus tour, faculty, and parent portal.",
    tech: ["WordPress", "PHP", "MySQL"],
    live: "#",
    github: "#",
  },
  {
    id: "p7",
    title: "Sri Ram Degree College",
    category: "school",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200&q=80",
    desc: "College website with courses, admissions online, notice board, and results portal.",
    tech: ["React", "Node", "MongoDB"],
    live: "#",
    github: "#",
  },
  {
    id: "p8",
    title: "Karnataka Kart",
    category: "ecommerce",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxvbmxpbmUlMjBzaG9wcGluZyUyMGVjb21tZXJjZXxlbnwwfHx8fDE3ODMxNDg4MTF8MA&ixlib=rb-4.1.0&q=85",
    desc: "Full-stack e-commerce store with product catalogue, cart, and secure checkout.",
    tech: ["React", "FastAPI", "MongoDB"],
    live: "#",
    github: "#",
  },
  {
    id: "p9",
    title: "Smart Marketing Agency",
    category: "business",
    image: "https://images.pexels.com/photos/13219418/pexels-photo-13219418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Corporate business website with services, case studies, and lead generation forms.",
    tech: ["React", "Tailwind", "SEO"],
    live: "#",
    github: "#",
  },
];

export const WHY_HIRE_ME = [
  { title: "Responsive Design", desc: "Flawless on mobile, tablet, and desktop.", icon: "Smartphone" },
  { title: "Fast Delivery", desc: "Ship faster without cutting corners on quality.", icon: "Zap" },
  { title: "SEO Friendly", desc: "Semantic HTML, meta, sitemap — built to rank.", icon: "Search" },
  { title: "Clean UI", desc: "Minimal, distraction-free interfaces that convert.", icon: "Sparkles" },
  { title: "Performance", desc: "Optimized images, code-splitting, blazing speed.", icon: "Gauge" },
  { title: "Ongoing Support", desc: "Monthly maintenance & priority bug fixes.", icon: "LifeBuoy" },
];

export const TESTIMONIALS = [
  {
    name: "Rakesh Gowda",
    role: "Owner, Malnad Retreat",
    text: "Sunil built our homestay website in record time. Bookings doubled within two months — the SEO and design work is exceptional.",
    avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&q=80",
  },
  {
    name: "Priya Sharma",
    role: "Founder, Brew & Bloom Café",
    text: "The café site feels warm and modern at the same time. Our online reservations went up 3x. Highly recommend Sunil for hospitality brands.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=80",
  },
  {
    name: "Dr. Naveen Kumar",
    role: "Principal, Vidyapeetha School",
    text: "Professional, patient, and fast. Sunil understood our admissions flow perfectly and delivered a website parents love using.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80",
  },
];

export const COUNTERS = [
  { label: "Projects Delivered", value: 250, suffix: "+" },
  { label: "Happy Clients", value: 180, suffix: "+" },
  { label: "Years Experience", value: 6, suffix: "" },
  { label: "Technologies", value: 15, suffix: "+" },
];
